<!--  -->
<template>
  <div class="coupon">
    <div class="left">
      <div class="price"><span class="dol">¥</span><span class="num">{{dealPrice(nowAcvitity.promotionPrice) }}</span><b>券后</b></div>
      <div class="origin">¥{{ dealPrice(nowAcvitity.price)}}</div>
    </div>
    <div class="right">{{ productDetail.initialSales + productDetail.realSales }}人已购</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { priceCount, priceFilterFloat } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {};
  },
   props: {
    nowAcvitity: {
      type: Object,
      default: () => {},
    },
    productDetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
     // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    dealPrice(price) {
      return priceFilterFloat(price);
    },
  },
  created() {},
  mounted() {
    console.log(this.nowAcvitity,888)
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 444px;
  height: 67px;
  padding: 0 18px;
  background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/discount-bg.png')
    no-repeat;
  background-size: 100%;
  .left {
    .price {
        display: flex;
        align-items: center;
      .dol {
         position: relative;
         top: 6px;
        color: #fff;
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
      }
      .num {
        padding-right: 7px;
        color: #fff;
        font-weight: 600;
        font-size: 33px;
      }
      b {
        display: inline-block;
        width: 43px;
        height: 24px;
        color: #ff2a07;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        background: #fff;
        border-radius: 5px;
      }
    }
    .origin {
      color: #fff;
      font-weight: 400;
      font-size: 18px;
    }
  }
  .right {
    color: #954505;
    font-weight: 500;
    font-size: 22px;
  }
}
</style>
